// extracted by mini-css-extract-plugin
export default {"commentInput":"Textarea_commentInput__WvGLD"};